export const isAppleMobileDevice = (): boolean => {
  // @ts-ignore
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
}
